import Study from '@/models/Study';

const GET_STUDIES = 'get_studies';
const GET_STUDIES_REQUEST = 'get_studies_request';
const GET_STUDIES_SUCCESS = 'get_studies_success';
const GET_STUDIES_ERROR = 'get_studies_error';

export { GET_STUDIES };

export default {
    state: {
        studies: [],
        loading: false,
        studies_errors: [],
    },
    mutations: {
        [GET_STUDIES_REQUEST]: (state) => {
            state.studies = [];
            state.loading = true;
            state.studies_errors = [];
        },
        [GET_STUDIES_SUCCESS]: (state, { studies }) => {
            state.studies = studies;
            state.loading = false;
            state.studies_errors = [];
        },
        [GET_STUDIES_ERROR]: (state, { errors }) => {
            state.studies = [];
            state.loading = false;
            state.studies_errors = errors;
        },
    },
    actions: {
        [GET_STUDIES]: ({ commit, rootState }, { clientId, params = {} }) => {
            if (!clientId) {
                clientId = rootState.trajectory.trajectory.client.id;
            }
            commit(GET_STUDIES_REQUEST);
            return new Promise((resolve, reject) => {
                const ClientStudies = Study.makeModel(`/clients/${clientId}/studies`);
                ClientStudies.collection(params)
                    .then(({items, meta}) => {
                        const studies = items;
                        commit(GET_STUDIES_SUCCESS, { studies });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_STUDIES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/studies.js